import { Routes } from "@angular/router";
import { environment } from "./environments/environment";
import { AppType } from "./shared/enums/app-type.enum";
import { RoutingPaths } from "./shared/enums/routing-paths.enum";
import { appTypeGuard } from "./shared/guard/app-type.guard";
import { procesStepValidityGuard } from "./shared/guard/proces-step-validity.guard";
import { tokenGuard } from "./shared/guard/token.guard";

const processRoutes = [
  {
    path: RoutingPaths.apk,
    canActivate: [procesStepValidityGuard],
    loadComponent: () =>
      import(
        "./components/process/steps/needs-analysis/needs-analysis.component"
      ).then((c) => c.NeedsAnalysisComponent),
  },
  {
    path: RoutingPaths.variants,
    canActivate: [procesStepValidityGuard],
    loadComponent: () =>
      import(
        "./components/process/steps/insurance-variant/insurance-variant.component"
      ).then((c) => c.InsuranceVariantComponent),
  },
  {
    path: RoutingPaths.insuranceData,
    canActivate: [procesStepValidityGuard],
    loadComponent: () =>
      import(
        "./components/process/steps/insurance-data/insurance-data.component"
      ).then((c) => c.InsuranceDataComponent),
  },
  {
    path: RoutingPaths.payment,
    canActivate: [appTypeGuard(AppType.Direct), procesStepValidityGuard],
    loadComponent: () =>
      import("./components/process/steps/payment/payment.component").then(
        (c) => c.PaymentComponent,
      ),
  },
  {
    path: RoutingPaths.createPolicy,
    canActivate: [appTypeGuard(AppType.Agent), procesStepValidityGuard],
    loadComponent: () =>
      import(
        "./components/process/steps/create-policy/create-policy.component"
      ).then((c) => c.CreatePolicyComponent),
  },
  { path: "**", redirectTo: "apk" },
];

export const routes: Routes = [
  {
    path: RoutingPaths.scb,
    children: [
      {
        path: RoutingPaths.myhome,
        title: "Assistance Mój Dom",
        canActivate: environment.appType === AppType.Direct ? [] : [tokenGuard],
        loadComponent: () =>
          import("./components/process/process.component").then(
            (c) => c.ProcessComponent,
          ),
        children: processRoutes,
      },
      {
        path: RoutingPaths.myhealth,
        canActivate: environment.appType === AppType.Direct ? [] : [tokenGuard],
        title: "Assistance Moje Zdrowie",
        loadComponent: () =>
          import("./components/process/process.component").then(
            (c) => c.ProcessComponent,
          ),
        children: processRoutes,
      },
      {
        path: `${RoutingPaths.remote}/:remoteId`,
        canActivate: [appTypeGuard(AppType.Direct)],
        children: [
          {
            path: RoutingPaths.policyData,
            loadComponent: () =>
              import(
                "./components/remote/policy-data/policy-data.component"
              ).then((c) => c.PolicyDataComponent),
          },
          { path: "**", redirectTo: RoutingPaths.policyData },
        ],
      },
      {
        path: RoutingPaths.invalid,
        canActivate: environment.appType === AppType.Direct ? [] : [tokenGuard],
        loadComponent: () =>
          import("./components/invalid/invalid.component").then(
            (c) => c.InvalidComponent,
          ),
      },
      {
        path: `${RoutingPaths.payment}/:transactionId/${RoutingPaths.status}`,
        canActivate: [appTypeGuard(AppType.Direct)],
        loadComponent: () =>
          import("./components/payment-status/payment-status.component").then(
            (c) => c.PaymentStatusComponent,
          ),
      },
      { path: "**", redirectTo: "myhome" },
    ],
  },
  { path: "**", redirectTo: "scb" },
];
